/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_Template_SuccessInputs */



/**
* | output |
* | --- |
* | "AD Template created successfully." |
*
* @param {Event_Group_Options_Create_Ad_Template_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_success = /** @type {((inputs?: Event_Group_Options_Create_Ad_Template_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèle de description audio créé avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Vorlage erfolgreich erstellt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello AD creato con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шаблон объявления успешно создан.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plantilla de AD creada exitosamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD模板创建成功。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD テンプレートが正常に作成されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD टेम्पलेट सफलतापूर्वक बनाया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo de anúncio criado com sucesso.")
	return /** @type {LocalizedString} */ ("AD Template created successfully.")
});